export default __webpack_public_path__ + "static/great-wall-marathon-3d45a488f55162ce4c07cf4e01587ad0.jpg";